import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';

/**
 * Service Worker Kill-Switch
 * ---------------------------
 * Aplikasi POS ini sebelumnya menggunakan Angular Service Worker (ngsw-worker.js)
 * yang menyebabkan bundle lama tetap ter-cache di browser user, sehingga user
 * harus melakukan "Empty Cache and Hard Reload" untuk mendapatkan versi baru.
 *
 * Karena POS selalu online (tidak butuh offline capability), Service Worker
 * dihilangkan. Kill-switch di bawah ini akan meng-unregister Service Worker
 * lama + menghapus semua CacheStorage pada user yang sudah pernah menginstall
 * SW sebelumnya. Setelah SW ter-unregister, refresh berikutnya akan langsung
 * mengambil bundle terbaru dari server.
 */
(async () => {
    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            if (registrations.length > 0) {
                await Promise.all(registrations.map(r => r.unregister()));
                console.info('[SW Kill-Switch] Unregistered', registrations.length, 'service worker(s).');
            }
        }
        if ('caches' in window) {
            const cacheKeys = await caches.keys();
            if (cacheKeys.length > 0) {
                await Promise.all(cacheKeys.map(k => caches.delete(k)));
                console.info('[SW Kill-Switch] Cleared', cacheKeys.length, 'cache storage(s).');
            }
        }
    } catch (e) {
        console.warn('[SW Kill-Switch] Failed to cleanup service worker/cache:', e);
    }
})();

platformBrowserDynamic().bootstrapModule(AppModule)
                        .catch(err => console.error(err));
